import { merchantApi } from '@/config/axios'

/** O2O 机构上下文 */
export interface O2oInstitutionContextVO {
  onboardingStatus: 'NONE' | 'PENDING' | 'APPROVED' | 'REJECTED'
  institutionId?: number
  institutionName?: string
  institutionStatus?: string
  applyId?: number
  applyNo?: string
  auditRemark?: string
  depositSatisfied?: boolean
  depositAvailable?: number
  depositNeedReplenish?: boolean
  depositRequired?: number
  depositBalance?: number
  depositFrozen?: number
}

/** 入驻申请提交 */
export interface O2oInstitutionApplyCreateVO {
  institutionName: string
  licenseNo: string
  licenseUrl?: string
  legalPerson: string
  idCardFront?: string
  idCardBack?: string
  contactPhone: string
  contactEmail?: string
  province?: string
  city?: string
  district?: string
  address: string
  serviceCategoryIds: number[]
  qualificationUrls?: string[]
  loginUsername?: string
  loginPassword: string
}

export interface O2oInstitutionApplyCreateResultVO {
  id: number
  applyNo: string
  auditStatus: number
}

export interface O2oInstitutionApplyStatusVO {
  id: number
  applyNo: string
  institutionName: string
  auditStatus: number
  auditRemark?: string
  auditTime?: string
  createTime?: string
}

export interface O2oInstitutionApplyCategoryVO {
  id: number
  parentId?: number
  name: string
  leaf?: boolean
  children?: O2oInstitutionApplyCategoryVO[]
}

/** 机构资料 */
export interface O2oInstitutionProfileVO {
  id: number
  name: string
  licenseNo: string
  licenseUrl?: string
  legalPerson: string
  idCardFront?: string
  idCardBack?: string
  contactPhone: string
  contactEmail?: string
  province?: string
  city?: string
  district?: string
  address: string
  status?: string
  serviceCategoryIds?: number[]
  qualificationUrls?: string[]
  createTime?: string
  depositRequired?: number
  depositBalance?: number
  depositFrozen?: number
  depositAvailable?: number
  depositSatisfied?: boolean
  depositNeedReplenish?: boolean
}

export interface O2oInstitutionProfileUpdateVO {
  name: string
  licenseUrl?: string
  legalPerson: string
  idCardFront?: string
  idCardBack?: string
  contactPhone: string
  contactEmail?: string
  province?: string
  city?: string
  district?: string
  address: string
}

/** 获取 O2O 机构上下文 */
export function getO2oInstitutionContext() {
  return merchantApi.get<O2oInstitutionContextVO>({ url: '/merchant-api/o2o/institution/context' })
}

/** 提交机构入驻申请 */
export function createO2oInstitutionApply(data: O2oInstitutionApplyCreateVO) {
  return merchantApi.post<O2oInstitutionApplyCreateResultVO>({
    url: '/merchant-api/o2o/institution/apply',
    data
  })
}

/** 查询入驻进度 */
export function getO2oInstitutionApplyStatus(params: { applyNo: string; phoneSuffix: string }) {
  return merchantApi.get<O2oInstitutionApplyStatusVO>({
    url: '/merchant-api/o2o/institution/apply/status',
    params
  })
}

/** 入驻可选品类树 */
export function getO2oInstitutionApplyCategoryTree() {
  return merchantApi.get<O2oInstitutionApplyCategoryVO[]>({
    url: '/merchant-api/o2o/institution/apply/category-tree'
  })
}

/** 获取机构资料 */
export function getO2oInstitutionProfile() {
  return merchantApi.get<O2oInstitutionProfileVO>({ url: '/merchant-api/o2o/institution/profile' })
}

/** 更新机构资料 */
export function updateO2oInstitutionProfile(data: O2oInstitutionProfileUpdateVO) {
  return merchantApi.put({ url: '/merchant-api/o2o/institution/profile', data })
}

/** 扩品类申请 */
export interface O2oInstitutionCategoryApplyVO {
  id: number
  applyNo: string
  institutionId: number
  currentCategoryIds?: number[]
  addCategoryIds?: number[]
  auditStatus: number
  auditRemark?: string
  auditTime?: string
  createTime?: string
}

export function createO2oInstitutionCategoryApply(data: { addCategoryIds: number[] }) {
  return merchantApi.post<O2oInstitutionCategoryApplyVO>({
    url: '/merchant-api/o2o/institution/category-apply/create',
    data
  })
}

export function getO2oInstitutionCategoryApplyLatest() {
  return merchantApi.get<O2oInstitutionCategoryApplyVO | null>({
    url: '/merchant-api/o2o/institution/category-apply/latest'
  })
}
